import Api from './../../../services/api';
import User from './../../../services/auth';
import Cookie from './../../Account/MyProfile/Widget/Cookie.vue';

export default {
  name: 'Header',
  components: {
    Cookie,
  },
  props: {
    displayMenu: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      user: null,
      marketICO: false,
      menuProject: false,
      menuFund: false,
      menuEditProfile: false,
    };
  },
  methods: {
    async signOut() {
      await Api.signOut();
    },
    openMenu() {
      $('#wrapper').toggleClass('toggled');
    },
    closeMenu() {
      $('#wrapper').removeClass('toggled');
      $("html, body").animate({ scrollTop: 0 }, "fast");
    },
  },
  mounted() {
    $('.dropdown-trigger').dropdown({
      inDuration: 300,
      outDuration: 225,
      hover: true, // Activate on hover
      constrainWidth: false, // If true, constrainWidth to the size of the dropdown activator.
      belowOrigin: true, // Displays dropdown below the button
      alignment: 'right', // Displays dropdown with edge aligned to the left of button
    });
  },
  created() {
    console.log('href:' + window.location);
    let market = window.location.pathname;
    let str = ['marketplace', 'product', 'service', 'checkout'];

    for (let i = 0; i < str.length; i++) {
      if (market.includes(str[i]) == true || market == '/') {
        this.marketICO = true;
        break;
      }
    }

    this.user = User.getUserData();
    console.log("this.user>>>>>>>>>>>>>>>>>>>>>>>>>>>>")
    console.log(this.user)
  },
};



// WEBPACK FOOTER //
// ./src/components/Headers/HeaderForAreLoggedIn/Header.component.js